module.exports = __webpack_public_path__ + "img/117.181a034.jpg";